// extracted by mini-css-extract-plugin
export default {"row":"WebsiteRow_row__u9cxC","text":"WebsiteRow_text__HByT6"};